import axios from 'axios'

const state = {
    tokens: [],
}

const getters = {
    tokens: state => state.tokens,
}

const actions = {
    async init({ commit }) {
        const response = await axios.get(`${process.env.VUE_APP_NODE_API_HOST}/tokens/google/owners`)
        commit('SET_TOKENS', response.data.data)
    },

    async authorizeGoogleApi({ commit }, options) {
        try {
            const auth2 = await gapi.auth2.init({
                client_id: process.env.VUE_APP_CLIENT_ID,
            })

            const { code } = await auth2.grantOfflineAccess({ scope: options.scopes })

            const response = await axios.post(`${process.env.VUE_APP_NODE_API_HOST}/tokens/google`, {
                code: code,
            })

            commit('CREATE_TOKEN', response.data.data)
            return response.data.data
        } catch (error) {
            throw error
        }
    },
}

const mutations = {
    SET_TOKENS(state, tokens) {
        state.tokens = tokens
    },
    CREATE_TOKEN(state, token) {
        const tokenFound = state.tokens.find(el => el.id === token.id)
        if (!tokenFound) {
            state.tokens.push(token)
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
